import { ArgumentNullException } from '../../../../utility/exception/argument-null.exception';
import { PrimitiveValueObject } from '../../../../utility/model/primitive-value-object.model';

export class SlackOAuthScope extends PrimitiveValueObject<string> {
  static create(value: string): SlackOAuthScope {
    return new SlackOAuthScope(value);
  }
}
